import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LanguageCode } from '@digilize/shared/definitions/src';
import { I18nService, LangOption } from '@digilize/shared/feature/modules/i18n/src';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'lsc-lang-switcher',
  templateUrl: './lang-switcher.component.html',
  styleUrls: ['./lang-switcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LangSwitcherComponent implements OnInit {
  defaultLang = '';
  currentLang;
  langChanges$ = this.translocoService.langChanges$;

  constructor(
    private translocoService: TranslocoService,
    private i18nService: I18nService
  ) {}

  ngOnInit(): void {
    this.defaultLang = this.translocoService.getDefaultLang();
  }

  handleLangChange(lang: LanguageCode) {
    this.i18nService.setLangAndSave(lang);
  }

  getLangOption(lang: LanguageCode, langOptions: LangOption[]): LangOption {
    return langOptions.find((option) => option.value === lang);
  }
}
